<template>
    <v-container wrap class="text-center">
        <v-progress-circular v-if="working" :size="90" :width="7" color="secondary" indeterminate
            class="mb-2"></v-progress-circular>
        <div :class="!isSmallerDisplay() ? 'centered' : ''">
            <v-card flat max-width="650px" light>
                <v-card-text v-if="updateCOF">
                    <div class="text-h4">{{ memberName }}</div>
                    <div class="text-subtitle-1">{{ $t("message.update_card_on_file") }}</div>
                </v-card-text>
                <v-list v-if="items && items.length > 0" class="text-left" outlined rounded>
                    <v-list-item v-for="(i, index) in items" :key="'item_' + index" link dense>
                        <v-list-item-content>
                            <v-list-item-title class="text-left">
                                {{ i.name }}
                                <v-icon size="20" class="ml-1" v-if="i.recurrent">mdi-sync</v-icon>
                                <v-icon size="20" class="ml-1" v-else-if="i.discount">mdi-tag-outline</v-icon>
                                <span v-if="i.interval" class="ml-1 text-caption">{{ i.interval }}</span>
                            </v-list-item-title>
                            <v-list-item-subtitle v-if="i.startDate" class="primary--text">
                                {{ $t("message.starts") }} {{ $d(new Date(i.startDate), "month_day_year", $i18n.locale)
                                }}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-content>
                            <v-list-item-title v-if="i.discount" class="text-right">
                                <span>-</span>
                                <span v-if="i.percent > 0">%{{ i.percent }}</span>
                                <span v-else>{{ currency }}{{ i.amount }}</span>
                            </v-list-item-title>
                            <v-list-item-title v-else class="text-right">
                                <span v-if="!i.recurrent">{{ i.quantity }}</span>
                                <span v-if="!i.recurrent" class="mr-1 ml-1">x</span>
                                {{ currency }}{{ i.amount }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                <v-card-text class="text-center text-h2" v-if="!working && !updateCOF">
                    {{ currency }}{{ total }}
                </v-card-text>
                <div v-if="!working">
                    <iframe ref="iframe" scrolling="no" frameborder="0" :style="{ height: iframeHeight }"
                        @load="onPayFormLoad" v-if="initPayformUrl" :src="initPayformUrl" width="100%"></iframe>
                </div>
                <v-card-actions v-if="!working">
                    <v-btn elevation="0" small block @click="cancelPayment()">Cancel</v-btn>
                </v-card-actions>
            </v-card>
            <v-card outlined class="mt-2">
                <v-card-text>
                    Test card VISA - <v-btn text @click="copyToClipboard('4005520000000939')">4005 5200 0000
                        0939</v-btn><br>
                    ADDRESS - <v-btn text @click="copyToClipboard('1307 Broad Hollow Road')">1307 Broad Hollow
                        Road</v-btn><br>
                    CVV - 123<br>
                    CVV FOR AMEX - 1234<br>
                    ZIP: 4048
                </v-card-text>
                <v-card-text>
                    Test card MasterCard - <v-btn text @click="copyToClipboard('5405001111111116')">5405 0011 1111
                        1116</v-btn><br>
                    ADDRESS - <v-btn text @click="copyToClipboard('1307 Broad Hollow Road')">1307 Broad Hollow
                        Road</v-btn><br>
                    CVV - 123<br>
                    CVV FOR AMEX - 1234<br>
                    ZIP: 4048
                </v-card-text>
            </v-card>
        </div>
    </v-container>
</template>

<script>
import PaymentsService from "@/services/PaymentsService";

export default {
    data() {
        return {
            transactionId: this.$route.params.transactionId,
            transactionData: {},
            working: true,
            memberName: null,
            updateCOF: false,
            postData: { routeFrom: 'bulk' },
            total: 0,
            currency: '$',
            items: [],
            discount: null,
            subscriptionStartDate: null,
            startsInFuture: false,
            willProcessNow: true,
            newTransactionId: null,
            alreadyCancelled: false,
            successfulTransaction: false,
            managedAcademyId: null,
            initPayformUrl: null,
            iframeWidth: '400px',
            iframeHeight: '445px'
        };
    },
    props: ["transactionDataOld"],
    components: {
    },
    beforeDestroy() {
        window.removeEventListener('message', this.handleEasypayPostMessage);
    },
    created() {
        if (this.isSmallerDisplay()) {
            this.iframeWidth = '300px';
            this.iframeHeight = '400px';
        }
        if (this.transactionData && this.transactionData.items) {
            this.setupTransactionDisplayData(this.transactionData);
        } else if (this.transactionData && this.transactionData.memberId && this.transactionData.action == 'update-card') {
            this.updateCOF = true;
            this.memberName = this.transactionData.memberName;
        }
    },
    mounted() {
        this.initPayment();
    },
    methods: {
        async handleEasypayPostMessage(e) {
            if (e.origin == 'https://easypay5.com') {
                const transactionId = this.transactionId;
                this.working = true;
                console.log('Back from easypay: ', e)

                const data = await PaymentsService.completeEasypayTransaction(this.managedAcademyId, this.transactionId, { encrypted: e.data, transaction: transactionId });
                if (data && data.success) {
                    this.successfulTransaction = true;
                    this.showAlert("success", this.$t("message.success"));
                    this.goToTransaction();

                } else {
                    this.showAlert("error", this.$t("message.error_generic"));
                }
            }
        },
        goToTransaction() {
            this.navigateTo({ name: 'transaction', params: { transactionId: this.transactionId } })
        },
        onPayFormLoad() {
            try {
                window.addEventListener('message', this.handleEasypayPostMessage);
            } catch (error) {
                console.error(
                    "Iframe resizing failed. This is expected if the iframe's 'src' is from a different domain due to browser security policies.",
                    error
                );
            }
        },
        async initPayment() {
            if (!this.transactionId)
                return;
            //else... we should have data
            const response = await PaymentsService.transaction(this.transactionId);
            this.transactionData = response.transaction;
            this.managedAcademyId = this.transactionData.managedAcademy._id;
            this.working = true;

            this.total = this.transactionData.amount;
            if (this.transactionData && this.transactionData.items)
                this.setupTransactionDisplayData(this.transactionData);
            try {
                const product = this.transactionData.product;
                let data = null;
                let payload = {
                    total: this.transactionData.amount,
                    interval: product ? product.interval : null,
                };
                payload.buyer = this.transactionData.buyer || this.transactionData.email;
                if (payload.buyer._id)
                    payload.buyer = payload.buyer._id;
                payload.transaction = this.transactionId;
                if (this.transactionData.subscriptionStartDate)
                    payload.startDate = this.getFormattedString(new Date(this.transactionData.subscriptionStartDate), "YYYY-MM-DD");
                else
                    payload.startDate = this.getNowDateString();
                data = await PaymentsService.initEasypayForm(this.managedAcademyId, payload);
                if (data && data.url) {
                    this.initPayformUrl = data.url;
                    const vm = this;
                    setTimeout(function () {
                        vm.working = false;
                    }, 500);
                } else {
                    console.log('ERROR with data: ', data);
                    this.working = false;
                    this.showAlert("error", this.$t("message.error_generic"));
                }
            } catch (err) {
                console.log(err)
                this.working = false;
                this.showAlert("error", this.$t("message.error_generic"));
            }
        },
        setupTransactionDisplayData(transactionData, skipItems) {
            if (transactionData.productData) {
                if (!this.items)
                    this.items = [];
                const recurrent = transactionData.productData.type == 'service' ? true : false
                this.items.push({
                    name: transactionData.productData.name,
                    amount: transactionData.productData.amountDecimal,
                    quantity: 1,
                    interval: transactionData.productData.interval ? this.getIntervalDisplay(transactionData.productData.interval) : null,
                    recurrent: recurrent,
                    startDate: recurrent ? transactionData.subscriptionStartDate : null
                });
            }
            if (!skipItems) {
                let items = [];
                for (const i of transactionData.items) {
                    items.push({
                        name: i.name,
                        amount: i.amountDecimal,
                        quantity: i.quantity
                    });
                }
                if (transactionData.discountAmount > 0) {
                    items.push({
                        name: this.$t("message.discount"),
                        discount: true,
                        amount: transactionData.discountAmount,
                    });
                } else if (transactionData.discountPercent > 0) {
                    items.push({
                        name: this.$t("message.discount"),
                        discount: true,
                        percent: transactionData.discountPercent,
                    });
                }

                if (transactionData.prorated && transactionData.prorated.amount) {
                    items.push({
                        name: this.$t("message.prorated_amount"),
                        amount: transactionData.prorated.amount,
                        quantity: 1,
                    });
                }
                this.items = this.items.concat(items);
            }

            if (transactionData.subscriptionStartDate && transactionData.recurrence) {
                if (transactionData.prorated && transactionData.prorated.amount > 0)
                    this.total = transactionData.prorated.amount;
                else
                    this.total = 0;
                this.startsInFuture = true;
                this.willProcessNow = this.checkPaymentDates();
            } else if (transactionData.recurrence) {
                this.total = transactionData.recurrence.totalAmount;
            } else {
                this.total = transactionData.amount;
            }
        },
    }
};
</script>

<style scoped>
.centered div {
    margin-left: auto;
    margin-right: auto;
}
</style>